// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-3Qo8bd","rightContent":"_J8CeeTNN","title":"_zxX2oebF","mainImage":"_UUe5OboI","confettiImage":"_yFOBN2vH"};